window.ondragstart = function () { return false; }

document.addEventListener("DOMContentLoaded", function () {

    document.addEventListener("click", function (event) {
        const link = event.target.closest(".set .payment_set");
        if (!link) return; // only run if <a> inside .set was clicked

        var $this = $(link); // now it's the correct <a>
        var $content = $this.next(".content");
        var $iconContainer = $this.find(".circle-chevron");

        if ($content.is(":visible")) {
            $content.slideUp(200);
            $iconContainer.removeClass("expanded").html(`
            <svg role="presentation" focusable="false" width="8" height="6" class="icon icon-chevron-bottom-small" viewBox="0 0 8 6">
                <path d="m1 1.5 3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
            </svg>
            `);
        } else {
            $(".content").slideUp(200);
            $(".set a .circle-chevron").removeClass("expanded").html(`
            <svg role="presentation" focusable="false" width="8" height="6" class="icon icon-chevron-bottom-small" viewBox="0 0 8 6">
                <path d="m1 1.5 3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
            </svg>
            `);

            $content.slideDown(200);
            $iconContainer.addClass("expanded").html(`
            <svg role="presentation" focusable="false" width="8" height="6" class="icon icon-chevron-bottom-small" viewBox="0 0 8 6">
                <path d="m1 3 3 3 3-3" fill="none" stroke="currentColor" stroke-width="1.5"></path>
            </svg>
            `);
        }
    });


    // Ensure script runs after the DOM loads
    function setupUpsellButtons() {
        document.querySelectorAll(".add-upsell").forEach(button => {
            button.addEventListener("click", function () {
                let variantId = this.getAttribute("data-id");

                if (!variantId) {
                    console.error("Error: Variant ID not found");
                    return;
                }

                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: variantId, quantity: 1 })
                })
                    .then(response => {
                        if (!response.ok) throw new Error("Network response was not ok");
                        return response.json();
                    })
                    .then(data => {
                        console.log("Added to cart:", data);

                        // Update cart drawer (if using AJAX cart)
                        if (window.Shopify && Shopify.onItemAdded) {
                            Shopify.onItemAdded(data);
                        } else {
                            location.reload(); // Reload if no AJAX cart is present
                        }
                    })
                    .catch(error => console.error("Error adding product:", error));
            });
        });
    }

    setupUpsellButtons(); // Run on page load
});


$(document).ready(function () {
    $('#view-more-upsell').click(function () {
        $('.hidden-upsell').slideDown();
        $(this).hide();
        $('#view-less-upsell').show();
    });

    $('#view-less-upsell').click(function () {
        $('.hidden-upsell').slideUp();
        $(this).hide();
        $('#view-more-upsell').show();
        $('html, body').animate({
            scrollTop: $('#upsell-products').offset().top
        }, 300);
    });
});

document.addEventListener('DOMContentLoaded', function () {
  function queryAllDeep(selector, root) {
    var results = [];
    var start = root || document;

    function walk(node) {
      if (!node) return;
      if (node.querySelectorAll) {
        results = results.concat(Array.from(node.querySelectorAll(selector)));
      }
      var elements = node.querySelectorAll ? node.querySelectorAll('*') : [];
      elements.forEach(function (el) {
        if (el.shadowRoot) walk(el.shadowRoot);
      });
    }

    walk(start);
    return results;
  }

  function forceShopifyChatSize() {
    var shopifyChat = document.getElementById('ShopifyChat');
    if (shopifyChat) {
      shopifyChat.style.setProperty('height', '58px', 'important');
      shopifyChat.style.setProperty('bottom', '0', 'important');
    }

    var buttons = queryAllDeep('button.chat-toggle');
    buttons.forEach(function (btn) {
      btn.style.setProperty('width', '48px', 'important');
      btn.style.setProperty('height', '48px', 'important');
      btn.style.setProperty('min-width', '48px', 'important');
      btn.style.setProperty('min-height', '48px', 'important');
      btn.style.setProperty('max-width', '48px', 'important');
      btn.style.setProperty('max-height', '48px', 'important');
    });

    var svgs = queryAllDeep(
      'button.chat-toggle.chat-toggle--icon-button.icon-only svg, button.chat-toggle.chat-toggle--icon-button.mobile-only svg'
    );
    svgs.forEach(function (svg) {
      svg.style.setProperty('width', '48px', 'important');
      svg.style.setProperty('height', '48px', 'important');
      svg.style.setProperty('min-width', '48px', 'important');
      svg.style.setProperty('min-height', '48px', 'important');
      svg.style.setProperty('max-width', '48px', 'important');
      svg.style.setProperty('max-height', '48px', 'important');
    });
  }

  forceShopifyChatSize();

  var observer = new MutationObserver(function () {
    forceShopifyChatSize();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['style', 'class']
  });

  setInterval(forceShopifyChatSize, 800);
});
